import axios from "axios";

export const BoombitAPI = axios.create({
    baseURL: "https://6128-165-227-165-134.eu.ngrok.io",
});
